<template>
  <QInput
    v-model="selectedValue"
    :bottom-slots="!!hint"
    dense
    :disable="disable"
    filled
    :label="label"
    :rules="rules"
    square
  >
    <template #append>
      <QIcon
        class="cursor-pointer"
        name="event"
      >
        <QPopupProxy ref="qDateProxy">
          <QDate
            v-model="selectedValue"
            mask="YYYY-MM-DD"
            :no-unset="noUnset"
            @update:model-value="() => $refs.qDateProxy.hide()"
          />
        </QPopupProxy>
      </QIcon>
    </template>
    <template #hint>
      <div>{{ hint }}</div>
    </template>
  </QInput>
</template>

<script>
export default {
  name: "Calendar",
  props: {
    modelValue: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "Date",
    },
    hint: {
      type: String,
      default: null,
    },
    disable: {
      type: Boolean,
    },
    rules: {
      type: Array,
      default: null,
    },
    noUnset: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
